import { CSS_CUSTOM_HEADER, loadCustomCss } from "../report-editor/z-components/panel-edit-css.js";

const COMPONENT_NAME = "z-composer";

export default function register() {
    class HTMLComponent extends HTMLElement {
        constructor() {
            super();
            this.innerHTML = null;
        }

        setComponents(editor, htmlContent) {
            const indexCustomHeader = htmlContent.indexOf(CSS_CUSTOM_HEADER);
            let customCss = "";
            if (indexCustomHeader !== -1) {
                const indexEndStyle = htmlContent.toLowerCase().indexOf("</style>", indexCustomHeader);
                customCss = htmlContent.substring(indexCustomHeader + CSS_CUSTOM_HEADER.length, indexEndStyle);
                htmlContent = htmlContent.substring(0, indexCustomHeader) + htmlContent.substring(indexEndStyle);
            }

            editor.setComponents(htmlContent);

            if (customCss) {
                loadCustomCss(editor, customCss);
            }
        }

        configComposer() {
            if (this.composer.contentWindow) {
                this.composer.contentWindow.tr = window.tr;
            }
            if (this.composer.contentWindow && this.composer.contentWindow.editor) {
                this.editor = this.composer.contentWindow.editor;
                this.editor.Panels.removeButton('options', 'export-template');
                this.editor.Panels.removeButton('options', 'report-editor-coding-cmd');
                this.editor.Panels.removeButton('options', 'report-editor-storage-cmd');
                this.editor.Panels.removeButton('options', 'gjs-open-import-template');
                this.editor.Panels.removeButton('options', 'gjs-toggle-images');

                this.setComponents(this.editor, this.currentValue || "");
                // this.editor.on('change:changesCount', ()=>{});
                this.editor.on('all', () => {
                    let changedValue = ("<style>" + this.editor.getCss() + "</style>" + this.editor.getHtml());
                    if (changedValue !== this.currentValue) {
                        this.currentValue = changedValue;
                        this.preview.contentDocument.querySelector('body').innerHTML = this.currentValue;
                        this.dispatchEvent(new Event("change", { bubbles: true }));
                    }
                });
            } else {
                setTimeout(function () {
                    this.configComposer();
                }.bind(this), 10);
            }
        }

        init() {
            if (this.initDone) { return; }
            this.initDone = true;

            const preview = document.createElement('iframe');
            preview.style = "border:1px solid #ced4da;padding:0;margin:0;box-sizing:border-box;background-color: #eceff5;width:100%;min-height:10rem;height:100%;display:" + (this.hasAttribute('readonly') ? "block" : "none");
            preview.onload = function () {
                preview.contentDocument.querySelector('body').innerHTML = (this.currentValue || "");
            }.bind(this);
            this.preview = preview;
            this.preview.classList.add('border', 'rounded');
            this.appendChild(preview);

            const composer = document.createElement('iframe');
            composer.src = '/node_modules/report-editor/dist/report-editor.html?' +
                'canvasStyles=' +
                    '/node_modules/@fortawesome/fontawesome-free/css/all.css,' +
                    '/' + window.APP.name + '/public/resources/global_css.css,' +
                    '/static/css/theme.css,/static/css/editor-canvas.css' +
                '&editorStyles=' +
                    '/static/css/editor.css,' +
                    '/node_modules/@fortawesome/fontawesome-free/css/all.css' +
                '&jsLibs=' +
                    '/node_modules/grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.min.js' +
                    ',/node_modules/htmlhint/dist/htmlhint.js'+
                '&plugins=' +
                    '/static/libs/report-editor/z-components/z-composer.js' +
                // '/static/libs/report-editor/z-components/index.js,' +
                // '/static/libs/report-editor/z-components/basics.js,' +
                // '/static/libs/report-editor/z-components/b-row-columns.js,' +
                // '/static/libs/report-editor/z-components/z-col.js,' +
                // '/static/libs/report-editor/z-components/z-error-feedback.js,' +
                // '/static/libs/report-editor/z-components/z-form.js,' +
                // '/static/libs/report-editor/z-components/z-button-form.js,' +
                // '/static/libs/report-editor/z-components/z-field.js,' +
                // '/static/libs/report-editor/z-components/z-list.js,' +
                // '/static/libs/report-editor/z-components/z-free-list.js' +
                '&config=' + JSON.stringify({ i18n: { detectLocale: false }, noticeOnUnload: false, plugins: ["gjs-preset-newsletter"] });
            composer.style = "border:1px solid #ced4da;margin:0;padding:0;width:100%;height:57rem;display:" + (this.hasAttribute('readonly') ? "none" : "block");
            composer.onload = () => {
                composer.contentWindow.tr = window.tr;
                // composer.contentWindow.fetch = window.fetch;
                // composer.contentWindow.waiter = window.waiter;
                // composer.contentWindow.APP = window.APP;
                // composer.contentWindow.bamzApi = window.getRestApi("$bamz");
                // composer.contentWindow.appApi = window.getRestApi(composer.contentWindow.APP.name);
                let script = composer.contentWindow.document.createElement("script");
                script.type = "module";
                script.innerHTML = `
                    import Popper from '/node_modules/popper.js/dist/popper.js' ;
                    import prettier from '/node_modules/prettier/esm/standalone.mjs' ;
                    import prettierHtml from '/node_modules/prettier/esm/parser-html.mjs' ;

                    window.prettier = prettier ;
                    window.prettierHtml = prettierHtml ;
                    window.Popper = Popper ;` ;

                let head = composer.contentWindow.document.head;
                head.appendChild(script);
            }

            this.composer = composer;
            this.composer.classList.add('border', 'rounded');
            this.appendChild(composer);
            this.configComposer();
        }

        connectedCallback() {
            this.init();
        }

        get value() {
            // if (!this.editor) { return null; }
            return this.currentValue;
        }

        set value(value) {
            this.currentValue = value;
            if (this.editor) {
                this.editor.setComponents(this.currentValue || "");
            }
        }

        static get observedAttributes() {
            return ['value', 'readonly'];
        }

        attributeChangedCallback(name, oldValue, newValue) {
            switch (name) {
                case 'value':
                    this.value = newValue;
                    break;
                case 'readonly':
                    this.applyReadonly();
                    break;
            }
        }

        applyReadonly() {
            const readonly = this.hasAttribute('readonly');
            if (this.preview) {
                this.preview.style.display = readonly ? "block" : "none";
            }
            if (this.composer) {
                this.composer.style.display = readonly ? "none" : "block";
            }
        }
    }
    customElements.define(COMPONENT_NAME, HTMLComponent);
}
